export default __webpack_public_path__ + "locales/cs/OAuth.json?hash=daee59eece8d85872140a88b44546299";